import React from 'react'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const TreeTab: React.FC = () => {
  const botId = useBotId()
  const location = useLocation()

  const designerHref = `/bots/${botId}`
  const isDesignerInHref = location.pathname.endsWith(designerHref)

  return (
    <DisableableLink key="tree-tab" to={designerHref}>
      <Tab size={18} label="Designer" active={isDesignerInHref} />
    </DisableableLink>
  )
}
